export default "__VITE_ASSET__f5b37863__"